<h2 mat-dialog-title>
  {{ 'boxes.qrCode.generatedQrCode' | translate }}
</h2>
<mat-dialog-content>
  <div class="qr-container">
    <img [src]="qrCode.url" [alt]="'boxes.qrCode.generatedQrCode' | translate" />
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()">
    {{ 'common.close' | translate }}
  </button>

  <span class="spacer"></span>

  <button mat-stroked-button (click)="downloadQRCode()">
    <mat-icon>download</mat-icon>
    {{ 'boxes.qrCode.download' | translate }}
  </button>

  <button mat-flat-button cdkFocusInitial (click)="printQRCode()">
    <mat-icon>print</mat-icon>
    {{ 'boxes.qrCode.print' | translate }}
  </button>
</mat-dialog-actions>
